// Bilingual dictionary (English + Hindi). Keys are dot-namespaced.
export const translations = {
  en: {
    "brand.name": "Anjali Herbal Life",
    "brand.full": "Anjali Herbal Life Ayurveda India LLP",
    "brand.tagline": "Premium Ayurveda. Modern Business.",

    "nav.home": "Home", "nav.dashboard": "Dashboard", "nav.products": "Products",
    "nav.orders": "Orders", "nav.wallet": "Wallet", "nav.income": "Income",
    "nav.referral": "Referral", "nav.team": "Team", "nav.kyc": "KYC",
    "nav.withdrawals": "Withdrawals", "nav.notifications": "Notifications",
    "nav.reports": "Reports", "nav.profile": "Profile", "nav.support": "Support",
    "nav.more": "More", "nav.admin": "Admin", "nav.logout": "Log out",
    "nav.settings": "Settings", "nav.users": "Users", "nav.audit": "Audit Logs",
    "nav.commissions": "Commissions",

    "cta.getStarted": "Get Started", "cta.login": "Login", "cta.register": "Register",
    "cta.activateNow": "Activate Now", "cta.shopNow": "Shop Now", "cta.viewAll": "View all",
    "cta.addToCart": "Add to Cart", "cta.buyNow": "Buy Now", "cta.checkout": "Checkout",
    "cta.continue": "Continue", "cta.submit": "Submit", "cta.save": "Save", "cta.cancel": "Cancel",
    "cta.share": "Share", "cta.copy": "Copy", "cta.export": "Export CSV", "cta.back": "Back",

    "landing.heroTitle": "Build a wellness business rooted in Ayurveda",
    "landing.heroSub": "Join Anjali Herbal Life as a distributor. Premium Ayurvedic products, transparent referral income, and a modern platform to grow.",
    "landing.trust1": "100% Ayurvedic", "landing.trust2": "Secure Payments", "landing.trust3": "Transparent Income",
    "landing.productsTitle": "Our Wellness Range", "landing.productsSub": "Authentic Ayurvedic products, crafted with heritage recipes.",
    "landing.oppTitle": "The Distributor Opportunity", "landing.oppSub": "Activate once, earn on every referral you empower.",
    "landing.step1": "Register free", "landing.step1d": "Create your account and get a unique Distributor ID instantly.",
    "landing.step2": "Activate", "landing.step2d": "Purchase the qualifying starter kit to unlock full income.",
    "landing.step3": "Refer & earn", "landing.step3d": "Share your link. Earn referral commission on each activation.",
    "landing.ctaTitle": "Ready to begin your Ayurveda journey?",

    "auth.welcomeBack": "Welcome back", "auth.loginSub": "Log in to your distributor account",
    "auth.createAccount": "Create your account", "auth.registerSub": "Join Anjali Herbal Life in a few steps",
    "auth.fullName": "Full Name", "auth.email": "Email", "auth.mobile": "Mobile Number",
    "auth.password": "Password", "auth.confirmPassword": "Confirm Password",
    "auth.sponsorId": "Sponsor / Referral ID", "auth.sponsorRequired": "Enter the referral ID of the person who invited you. This is required.", "auth.aadhaar": "Aadhaar Number", "auth.address": "Address",
    "auth.state": "State", "auth.city": "City", "auth.pincode": "Pincode",
    "auth.otp": "Enter OTP", "auth.sendOtp": "Send OTP", "auth.verifyOtp": "Verify & Register",
    "auth.acceptTerms": "I accept the Terms & Conditions",
    "auth.noAccount": "Don't have an account?", "auth.haveAccount": "Already have an account?",
    "auth.otpSent": "OTP sent to your email & mobile",
    "auth.devOtp": "Demo OTP (email delivery is simulated)",
    "auth.tryDemo": "or try a demo",
    "auth.demoDistributor": "Distributor Demo",
    "auth.demoAdmin": "Admin Demo",

    "status.red": "Activation Pending", "status.green": "Active",
    "status.redDesc": "Registered — not activated yet", "status.greenDesc": "Activated distributor",

    "dash.title": "Dashboard", "dash.greeting": "Namaste",
    "dash.accountStatus": "Account Status", "dash.walletBalance": "Wallet Balance",
    "dash.totalIncome": "Total Income", "dash.todayIncome": "Today's Income",
    "dash.totalOrders": "Total Orders", "dash.referralCount": "Referrals",
    "dash.activeTeam": "Active Team", "dash.rank": "Rank",
    "dash.activateBanner": "Activate your distributor account",
    "dash.activateBannerSub": "Purchase qualifying products worth",
    "dash.activeMsg": "Your distributor account is active.",
    "dash.incomeOverview": "Income Overview (7 days)", "dash.quickActions": "Quick Actions",
    "dash.incomeBreakdown": "Income Breakdown", "dash.incomeBreakdownSub": "Where your total earnings come from",
    "dash.recentOrders": "Recent Orders", "dash.recentTxns": "Recent Transactions",
    "dash.rankSoon": "Coming in Phase 2",
    "dash.currentRank": "Current Rank", "dash.nextRank": "Next Rank", "dash.topRank": "Top Rank",

    "qa.shop": "Shop Products", "qa.share": "Share Referral", "qa.orders": "My Orders",
    "qa.wallet": "My Wallet", "qa.team": "My Team", "qa.kyc": "KYC", "qa.support": "Support",

    "wallet.available": "Available Balance", "wallet.pending": "Pending Balance",
    "wallet.earned": "Total Earned", "wallet.withdrawn": "Total Withdrawn",
    "wallet.transactions": "Transactions", "wallet.withdraw": "Request Withdrawal",

    "referral.title": "Your Referral", "referral.link": "Your Referral Link",
    "referral.code": "Referral Code", "referral.qr": "Referral QR Code",
    "referral.copied": "Copied to clipboard", "referral.eligibleNote": "You earn commission on each activation.",
    "referral.lockedNote": "Activate your account to unlock referral income.",

    "kyc.title": "KYC Verification", "kyc.pan": "PAN Number", "kyc.aadhaar": "Aadhaar Number",
    "kyc.holder": "Account Holder Name", "kyc.bank": "Bank Account Number",
    "kyc.ifsc": "IFSC Code", "kyc.bankName": "Bank Name", "kyc.status": "KYC Status",
    "kyc.notStarted": "Not Started", "kyc.pending": "Pending", "kyc.verified": "Verified", "kyc.rejected": "Rejected",

    "order.number": "Order", "order.total": "Total", "order.status": "Status",
    "order.date": "Date", "order.invoice": "Invoice", "order.items": "Items",
    "order.subtotal": "Subtotal", "order.gst": "GST", "order.payNow": "Pay Now",

    "cart.title": "Shopping Cart", "cart.empty": "Your cart is empty", "cart.qty": "Qty",
    "cart.remove": "Remove", "cart.summary": "Order Summary",

    "checkout.title": "Checkout", "checkout.shipping": "Shipping Address", "checkout.placeOrder": "Place Order & Pay",

    "empty.orders": "No orders yet", "empty.income": "No income yet", "empty.referrals": "No referrals yet",
    "empty.notifications": "No notifications", "empty.wallet": "No transactions yet", "empty.team": "No team members yet",

    "admin.title": "Admin Panel", "admin.totalUsers": "Total Users", "admin.redUsers": "RED Users",
    "admin.greenUsers": "GREEN Users", "admin.todayReg": "Today's Registrations",
    "admin.todayAct": "Today's Activations", "admin.todayOrders": "Today's Orders",
    "admin.todayRevenue": "Today's Revenue", "admin.totalRevenue": "Total Revenue",
    "admin.pendingKyc": "Pending KYC", "admin.pendingWd": "Pending Withdrawals",

    "common.loading": "Loading...", "common.status": "Status", "common.amount": "Amount",
    "common.date": "Date", "common.type": "Type", "common.name": "Name", "common.actions": "Actions",
    "common.all": "All", "common.search": "Search",
  },
  hi: {
    "brand.name": "अंजलि हर्बल लाइफ",
    "brand.full": "अंजलि हर्बल लाइफ आयुर्वेद इंडिया एलएलपी",
    "brand.tagline": "प्रीमियम आयुर्वेद। आधुनिक व्यापार।",

    "nav.home": "होम", "nav.dashboard": "डैशबोर्ड", "nav.products": "उत्पाद",
    "nav.orders": "ऑर्डर", "nav.wallet": "वॉलेट", "nav.income": "आय",
    "nav.referral": "रेफ़रल", "nav.team": "टीम", "nav.kyc": "केवाईसी",
    "nav.withdrawals": "निकासी", "nav.notifications": "सूचनाएँ",
    "nav.reports": "रिपोर्ट", "nav.profile": "प्रोफ़ाइल", "nav.support": "सहायता",
    "nav.more": "और", "nav.admin": "एडमिन", "nav.logout": "लॉग आउट",
    "nav.settings": "सेटिंग्स", "nav.users": "उपयोगकर्ता", "nav.audit": "ऑडिट लॉग",
    "nav.commissions": "कमीशन",

    "cta.getStarted": "शुरू करें", "cta.login": "लॉगिन", "cta.register": "रजिस्टर",
    "cta.activateNow": "अभी सक्रिय करें", "cta.shopNow": "अभी खरीदें", "cta.viewAll": "सभी देखें",
    "cta.addToCart": "कार्ट में जोड़ें", "cta.buyNow": "अभी खरीदें", "cta.checkout": "चेकआउट",
    "cta.continue": "जारी रखें", "cta.submit": "जमा करें", "cta.save": "सहेजें", "cta.cancel": "रद्द करें",
    "cta.share": "शेयर करें", "cta.copy": "कॉपी करें", "cta.export": "CSV निर्यात", "cta.back": "वापस",

    "landing.heroTitle": "आयुर्वेद पर आधारित वेलनेस व्यापार बनाएं",
    "landing.heroSub": "अंजलि हर्बल लाइफ में डिस्ट्रीब्यूटर के रूप में जुड़ें। प्रीमियम आयुर्वेदिक उत्पाद, पारदर्शी रेफ़रल आय और बढ़ने का आधुनिक मंच।",
    "landing.trust1": "100% आयुर्वेदिक", "landing.trust2": "सुरक्षित भुगतान", "landing.trust3": "पारदर्शी आय",
    "landing.productsTitle": "हमारी वेलनेस रेंज", "landing.productsSub": "प्रामाणिक आयुर्वेदिक उत्पाद, पारंपरिक व्यंजनों से बने।",
    "landing.oppTitle": "डिस्ट्रीब्यूटर अवसर", "landing.oppSub": "एक बार सक्रिय करें, हर रेफ़रल पर कमाएँ।",
    "landing.step1": "मुफ़्त रजिस्टर", "landing.step1d": "अपना खाता बनाएं और तुरंत यूनिक डिस्ट्रीब्यूटर आईडी पाएं।",
    "landing.step2": "सक्रिय करें", "landing.step2d": "पूरी आय अनलॉक करने हेतु स्टार्टर किट खरीदें।",
    "landing.step3": "रेफ़र करें और कमाएँ", "landing.step3d": "अपना लिंक शेयर करें। हर सक्रियण पर रेफ़रल कमीशन कमाएँ।",
    "landing.ctaTitle": "अपनी आयुर्वेद यात्रा शुरू करने के लिए तैयार हैं?",

    "auth.welcomeBack": "वापसी पर स्वागत है", "auth.loginSub": "अपने डिस्ट्रीब्यूटर खाते में लॉगिन करें",
    "auth.createAccount": "अपना खाता बनाएं", "auth.registerSub": "कुछ ही चरणों में अंजलि हर्बल लाइफ से जुड़ें",
    "auth.fullName": "पूरा नाम", "auth.email": "ईमेल", "auth.mobile": "मोबाइल नंबर",
    "auth.password": "पासवर्ड", "auth.confirmPassword": "पासवर्ड पुष्टि करें",
    "auth.sponsorId": "स्पॉन्सर / रेफ़रल आईडी", "auth.sponsorRequired": "जिसने आपको आमंत्रित किया है उसकी रेफ़रल आईडी दर्ज करें। यह अनिवार्य है।", "auth.aadhaar": "आधार नंबर", "auth.address": "पता",
    "auth.state": "राज्य", "auth.city": "शहर", "auth.pincode": "पिनकोड",
    "auth.otp": "ओटीपी दर्ज करें", "auth.sendOtp": "ओटीपी भेजें", "auth.verifyOtp": "सत्यापित करें और रजिस्टर करें",
    "auth.acceptTerms": "मैं नियम व शर्तें स्वीकार करता/करती हूँ",
    "auth.noAccount": "खाता नहीं है?", "auth.haveAccount": "पहले से खाता है?",
    "auth.otpSent": "आपके ईमेल और मोबाइल पर ओटीपी भेजा गया",
    "auth.devOtp": "डेमो ओटीपी (ईमेल डिलीवरी सिम्युलेटेड है)",
    "auth.tryDemo": "या डेमो आज़माएँ",
    "auth.demoDistributor": "डिस्ट्रीब्यूटर डेमो",
    "auth.demoAdmin": "एडमिन डेमो",

    "status.red": "सक्रियण लंबित", "status.green": "सक्रिय",
    "status.redDesc": "रजिस्टर्ड — अभी सक्रिय नहीं", "status.greenDesc": "सक्रिय डिस्ट्रीब्यूटर",

    "dash.title": "डैशबोर्ड", "dash.greeting": "नमस्ते",
    "dash.accountStatus": "खाता स्थिति", "dash.walletBalance": "वॉलेट बैलेंस",
    "dash.totalIncome": "कुल आय", "dash.todayIncome": "आज की आय",
    "dash.totalOrders": "कुल ऑर्डर", "dash.referralCount": "रेफ़रल",
    "dash.activeTeam": "सक्रिय टीम", "dash.rank": "रैंक",
    "dash.activateBanner": "अपना डिस्ट्रीब्यूटर खाता सक्रिय करें",
    "dash.activateBannerSub": "योग्य उत्पाद खरीदें, मूल्य",
    "dash.activeMsg": "आपका डिस्ट्रीब्यूटर खाता सक्रिय है।",
    "dash.incomeOverview": "आय अवलोकन (7 दिन)", "dash.quickActions": "त्वरित क्रियाएँ",
    "dash.incomeBreakdown": "आय विवरण", "dash.incomeBreakdownSub": "आपकी कुल कमाई कहाँ से आती है",
    "dash.recentOrders": "हाल के ऑर्डर", "dash.recentTxns": "हाल के लेनदेन",
    "dash.rankSoon": "फेज़ 2 में आ रहा है",
    "dash.currentRank": "वर्तमान रैंक", "dash.nextRank": "अगली रैंक", "dash.topRank": "सर्वोच्च रैंक",

    "qa.shop": "उत्पाद खरीदें", "qa.share": "रेफ़रल शेयर करें", "qa.orders": "मेरे ऑर्डर",
    "qa.wallet": "मेरा वॉलेट", "qa.team": "मेरी टीम", "qa.kyc": "केवाईसी", "qa.support": "सहायता",

    "wallet.available": "उपलब्ध बैलेंस", "wallet.pending": "लंबित बैलेंस",
    "wallet.earned": "कुल अर्जित", "wallet.withdrawn": "कुल निकाला",
    "wallet.transactions": "लेनदेन", "wallet.withdraw": "निकासी अनुरोध",

    "referral.title": "आपका रेफ़रल", "referral.link": "आपका रेफ़रल लिंक",
    "referral.code": "रेफ़रल कोड", "referral.qr": "रेफ़रल क्यूआर कोड",
    "referral.copied": "क्लिपबोर्ड पर कॉपी किया गया", "referral.eligibleNote": "आप हर सक्रियण पर कमीशन कमाते हैं।",
    "referral.lockedNote": "रेफ़रल आय अनलॉक करने हेतु अपना खाता सक्रिय करें।",

    "kyc.title": "केवाईसी सत्यापन", "kyc.pan": "पैन नंबर", "kyc.aadhaar": "आधार नंबर",
    "kyc.holder": "खाताधारक का नाम", "kyc.bank": "बैंक खाता संख्या",
    "kyc.ifsc": "आईएफएससी कोड", "kyc.bankName": "बैंक का नाम", "kyc.status": "केवाईसी स्थिति",
    "kyc.notStarted": "शुरू नहीं", "kyc.pending": "लंबित", "kyc.verified": "सत्यापित", "kyc.rejected": "अस्वीकृत",

    "order.number": "ऑर्डर", "order.total": "कुल", "order.status": "स्थिति",
    "order.date": "तारीख", "order.invoice": "इनवॉइस", "order.items": "आइटम",
    "order.subtotal": "उप-योग", "order.gst": "जीएसटी", "order.payNow": "अभी भुगतान करें",

    "cart.title": "शॉपिंग कार्ट", "cart.empty": "आपका कार्ट खाली है", "cart.qty": "मात्रा",
    "cart.remove": "हटाएँ", "cart.summary": "ऑर्डर सारांश",

    "checkout.title": "चेकआउट", "checkout.shipping": "शिपिंग पता", "checkout.placeOrder": "ऑर्डर करें और भुगतान करें",

    "empty.orders": "अभी कोई ऑर्डर नहीं", "empty.income": "अभी कोई आय नहीं", "empty.referrals": "अभी कोई रेफ़रल नहीं",
    "empty.notifications": "कोई सूचना नहीं", "empty.wallet": "अभी कोई लेनदेन नहीं", "empty.team": "अभी कोई टीम सदस्य नहीं",

    "admin.title": "एडमिन पैनल", "admin.totalUsers": "कुल उपयोगकर्ता", "admin.redUsers": "रेड उपयोगकर्ता",
    "admin.greenUsers": "ग्रीन उपयोगकर्ता", "admin.todayReg": "आज के रजिस्ट्रेशन",
    "admin.todayAct": "आज के सक्रियण", "admin.todayOrders": "आज के ऑर्डर",
    "admin.todayRevenue": "आज का राजस्व", "admin.totalRevenue": "कुल राजस्व",
    "admin.pendingKyc": "लंबित केवाईसी", "admin.pendingWd": "लंबित निकासी",

    "common.loading": "लोड हो रहा है...", "common.status": "स्थिति", "common.amount": "राशि",
    "common.date": "तारीख", "common.type": "प्रकार", "common.name": "नाम", "common.actions": "क्रियाएँ",
    "common.all": "सभी", "common.search": "खोजें",
  },
};
